import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { ScaAction } from '../hooks/useScaModal';

interface ScaContextValue {
  pendingScaAction: ScaAction | null;
  clearScaAction: () => void;
}

const ScaContext = createContext<ScaContextValue | null>(null);

export function ScaContextProvider({
  children,
  pendingScaAction,
  clearScaAction,
}: Readonly<{ children: ReactNode; pendingScaAction: ScaAction | null; clearScaAction: () => void }>) {
  const value = useMemo(() => ({ pendingScaAction, clearScaAction }), [pendingScaAction, clearScaAction]);
  return (
    <ScaContext.Provider value={value}>
      {children}
    </ScaContext.Provider>
  );
}

export function useScaContext(): ScaContextValue {
  const ctx = useContext(ScaContext);
  if (!ctx) throw new Error('useScaContext must be used within ScaContextProvider');
  return ctx;
}
